require([
    'dayjs',
    'ch_utils',
    'jquery',
    'semantic',
    'services',
    'ch_header',
    'ch_form_validation',
    'semantic-calendar',
    'ch_semantic_responsive',
    'ch_welcome_overlay',
], function(dayjs, utils) {
    var validator = CH.validate('form_GiftCard', {
        rules: {
            description: {
                maxlength: 300
            }
        }
    });

    var $form;
    var $giftCardDealSection;
    var $giftCardThumbs;
    var $mainImage;
    var $templateField;

    var maxCount = 300;
    var originalPrice;

    function calculateGiftCardDeal() {
        var amountOff;
        var amount;

        $giftCardDealSection.hide();

        if (CH.giftCardDealValue) {
            amount = utils.usdToFloat($('.js-gift-card-section-price', $form).text());
            amountOff = (CH.giftCardDealValue * amount / 100);
            if (CH.giftCardDealMaxSavingsAmount) {
                amountOff = Math.min(amountOff, CH.giftCardDealMaxSavingsAmount);
            }

            $('.js-gift-card-deal', $giftCardDealSection).html(utils.formatToUSD(amountOff));
            $('.js-gift-card-deal-total', $giftCardDealSection).html(
                utils.formatToUSD(Number(amount - amountOff))
            );

            $giftCardDealSection.show();
        }
    }

    function selectGiftCardImage(target) {

        // set new selected thumb
        $giftCardThumbs.removeClass('selected');
        target.addClass('selected');

        // change main image
        $mainImage.attr('src', target.find('.thumbnail').attr('src'));

        // make sure form is all set
        $templateField.val(target.data('id'));
    }

    function initPage() {
        $form = $('#form_GiftCard');
        $giftCardDealSection = $('#gift-card-deal-section');
        $giftCardThumbs = $('.js-gift-card');
        $mainImage = $('#selected-gift-card img');
        $templateField = $('#template_id');
        originalPrice = utils.usdToFloat($('.js-gift-card-section-price', $form).text());
        $('.ui.accordion').accordion({
            exclusive: false
        });

        $('.js-tooltip-field').popup();

        $('.delivery_date').calendar({
            type: 'date',
            minDate: new Date(),
            formatter: {
                date: function (date, settings) {
                    return dayjs(date).format('MM/DD/YYYY');
                }
            }
        });

        var descriptionElem = $._("description");
        var characterCounterElem = $._("characters-remaining");

        descriptionElem.on('input', function(e) {
            characterCounter(this, maxCount, characterCounterElem);
        });

        $._('seats').change(function() {
            var seatsCount = $(this).val();
            handleSeatChange(seatsCount);
        });

        // Handler for selection of thumbnail images
        $giftCardThumbs.on('click', function(e) {
            e.preventDefault();
            selectGiftCardImage($(this));
        });

        calculateGiftCardDeal();
    }

    function handleSeatChange(seatsCount) {
        $('.js-gift-card-section-price', $form).text(utils.formatToUSD(seatsCount * originalPrice));
        calculateGiftCardDeal();
    }

    $(function() {
        initPage();
    });

});
